import styled from 'styled-components'
import { space, typography, color, layout } from 'styled-system'

const StyledText = styled.div`
  ${space}
  ${color}
  ${typography}
  ${layout}
`
StyledText.defaultProps = {
  letterSpacing: 'text',
  fontSize: 'text.regular',
  lineHeight: 'text.regular'
}

const Text = ({ variant = 'text.regular', ...others }) =>
  <StyledText fontSize={variant} lineHeight={variant} {...others} />

export default Text
